<div class="row">
  <div class="col-12">
    <div class="row">
      <h1 class="col-12">Creation de page</h1>
      <div class="col-4"> 
        <div class="row">
          <h2 class="col-12">configuration</h2>
        </div>
      </div>
      <div class="col-8">
        <div class="row">
            <h2 class="col-12">Aperçu</h2>
        </div>
      </div>
    </div>
  </div>
</div>
